/**
 * @file index.tsx
 * @module app/modules/sales-management/sales-representative/index
 * @description Implements the index interface for sales-management operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import CustomerManagement from './customer-management/customer-management';
import Dashboard from './dashboard/dashboard';
import Orders from './orders/orders';
import Reports from './reports/reports';
import Notifications from './notifications';
import TargetTracking from './target-tracking/target-management';
const SalesRepresentativeIndex = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={<Navigate to="sales-management/representative/dashboard" />}
          />
          <Route
            path="dashboard"
            element={
              <>
                <Dashboard />
              </>
            }
          />
          <Route
            path="customer-management"
            element={
              <>
                <CustomerManagement />
              </>
            }
          />
          <Route
            path="orders"
            element={
              <>
                <Orders />
              </>
            }
          />
          <Route
            path="target-tracking"
            element={
              <>
                <TargetTracking />
              </>
            }
          />
          <Route
            path="notifications"
            element={
              <>
                <Notifications />
              </>
            }
          />
          <Route
            path="report-and-performance"
            element={
              <>
                <Reports />
              </>
            }
          />
          <Route path="*" element={<Navigate to="/error/404" />} />
        </Route>
      </Routes>
    </>
  );
};
export default SalesRepresentativeIndex;
